// @flow
import { spawn, call, all } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';

import { watchFetchBoostData } from '../boost/boost';
import { watchFetchBoostsData } from '../boosts/boosts';
import { watchFetchBaseData } from '../app/base';
import { watchFetchSaleData } from '../app/sale';
import { watchSocialEcommData } from '../app/social-ecomm';
import { watchFetchProducts } from '../fetchProducts/fetchProducts';
import { watchUpdateCart } from '../cart/cart';
import { watchUpdateFavorites } from '../favorites/favorites';
import { watchFetchAdminData } from '../admin/admin';
import watchFetchUserData from '../user/user';

export default function* rootSaga(): Saga<void> {
  const sagas = [
    watchFetchBoostData,
    watchFetchBoostsData,
    watchFetchBaseData,
    watchFetchSaleData,
    watchFetchProducts,
    watchUpdateCart,
    watchUpdateFavorites,
    watchFetchAdminData,
    watchFetchUserData,
    watchSocialEcommData,
  ];

  /* 
    We loop through sagas here so that we can call spawn (https://redux-saga.js.org/docs/api/) on each worker. 
    Putting them in a while loop allows us to be able to restart the worker in the event of 
    failure (https://redux-saga.js.org/docs/advanced/RootSaga.html#keeping-everything-alive). 
  */
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            // TODO: clean up error messages
            console.log(error);
          }
        }
      })
    )
  );
}
